<template>
  <div v-if="initializated && isPolicyConsentNeeded && !thereIsAnError" class="consents-container" :class="brandClass">
    <div class="consents-title" :class="brandClass" v-for="(usage, index) in getUserConsentsUsageTextsByTagName('header')" :key="`policy-header-${index}`">
      <div class="consents-usage-text" :id="'policy-header-consents-usage-text'">{{usage.text}}</div>
      <OneTippy
        :name="`policy-header-popup-${index}`"
        :visible="usage.popupVisible"
        v-if="usage.popup"
        :html="usage.popup"
        :placement="'top-start'"
        :maxWidth="500"
        :labelledBy="'policy-header-consents-usage-text'"
        :brandClass="brandClass"
      />
    </div>
    <div class="consents-info" :class="brandClass" v-for="(usage, index) in getUserConsentsUsageTextsByTagName('beforeUsageDef')" :key="`policy-before-${index}`">
      <div class="consents-usage-text" :id="'policy-before-consents-usage-text'">{{usage.text}}</div>
      <OneTippy
        :name="`policy-before-popup-${index}`"
        :visible="usage.popupVisible"
        v-if="usage.popup"
        :html="usage.popup"
        :placement="'top-start'"
        :maxWidth="500"
        :labelledBy="'policy-before-consents-usage-text'"
        :brandClass="brandClass"
      />
    </div>
    <div class="all-consents" :class="brandClass">
      <div v-for="(definition, index) in this.currentPolicy.usageDefinitions" :key="`definition-${index}`">
        <div v-if="isProfileSection">
          <div v-if="definition.usages && definition.usages.length>1" class="consents-info">
            <div :id="`definition-usage-${index}-combined-primary-label`" v-html="definition.textPrimary" class="consents-usage-text">
            </div>
            <OneTippy
              :brandClass="brandClass"
              :labelledBy="`definition-usage-${index}-combined-primary-label`"
              :name="`primary-popup-${index}`"
              v-if="definition.textSecondary"
              :html="definition.textSecondary"
              :placement="'bottom-start'"
              :maxWidth="500"
            />
          </div>
          <div v-for="(usage, index2) in definition.usages" :key="`definition-usage-${index2}`" class="checkbox-container terms-container consents-checkbox-container">
            <OneCheckbox
              :brandClass="brandClass" 
              v-model="form.check[usage.id]" 
              :form="v$.form"     
              :paramName="'check'"
              :id="'policy_check_'+index2+'_'+usage.id"
              @input="updateValue(usage.id, definition, false)"
              :required="usage.variant=='MANDATORY'"
              :labelledBy="'policy-label'"
            />
            <div v-if="getTextPrimary(definition, usage)" class="consents-usage-label" >
              <p :class="[brandClass,{'invalid':v$.form.check.$dirty && !form.check[usage.id] && usage.variant=='MANDATORY'}]">
                <span id="policy-label" v-html="getTextPrimary(definition, usage)" ></span>
                <span v-if="usage.variant=='MANDATORY'">*</span>
                <OneTippy
                  v-if="getUsageDefinitionSecondary(definition)"
                  :html="getUsageDefinitionSecondary(definition)"
                  :name="`policy-consents-tooltip-${policyIndex}`"
                  :visible="true"
                  :placement="'top-start'"
                  :maxWidth="500"
                  :labelledBy="'policy-label'"
                  :brandClass="brandClass"
                />
              </p>
            </div>
            <div v-else class="consents-usage-label">
              <p id="policy-label" class="fallback" :class="[brandClass,{'invalid':v$.form.check.$dirty && !form.check[usage.id] && usage.variant=='MANDATORY'}]">
                {{ ctaLabelPrefix }}
                <a :href="fallbackLink" style="display: inline-block;" target="_blank" rel="noopener noreferrer">
                  {{ ctaLabel }}
                </a>
                {{ ctaLabelSuffix }}
                <span v-if="usage.variant=='MANDATORY'">*</span>
              </p>
            </div>
            <div class="checkbox-error">
              <span v-if="!form.check[usage.id] && v$.form.check.$dirty && usage.variant=='MANDATORY'" :class="brandClass">
                {{ errorRequiredLabel }}
              </span>
            </div>
          </div>
        </div>
        <div v-else class="checkbox-container terms-container consents-checkbox-container">
          <template v-if="!checkImplicitVariantInsideUsageDefinition(definition)">
                          <!-- @input="checkboxCombinedChange(definition)" -->
            <OneCheckbox
              :brandClass="brandClass"
              :id="`definition-usage-${index}-combined-checkbox-${definition.usages[0].id}`"
              v-model="form.check[definition.usages[0].id]" 
              @input="updateValue(definition.usages[0].id, definition, true)"
              :required="definition.usages[0].variant=='MANDATORY'"
              :form="v$.form"
              :paramName="'check'"
              :labelledBy="`definition-usage-${index}-combined-checkbox-label-${definition.usages[0].id}`"
            ></OneCheckbox>
              <div v-if="getTextPrimaryCombined(definition)" class="consents-usage-label">
                <p :class="[brandClass,{'invalid':v$.form.check.$dirty && !form.check[definition.usages[0].id] && definition.usages[0].variant=='MANDATORY'}]">
                  <span v-html="getTextPrimaryCombined(definition)"  id="policy-label"></span>
                  <span v-if="definition.usages[0].variant=='MANDATORY'">*</span>
                  <OneTippy
                    v-if="getUsageDefinitionSecondary(definition)"
                    :html="getUsageDefinitionSecondary(definition)"
                    :name="`policy-consents-tooltip-${policyIndex}`"
                    :visible="true"
                    :placement="'bottom-start'"
                    :maxWidth="500"
                    :labelledBy="'policy-label'"
                    :brandClass="brandClass"
                  />
                </p>
              </div>
              <div v-else class="consents-usage-label">
                <p id="policy-label" class="fallback" :class="[brandClass,{'invalid':v$.form.check.$dirty && !form.check[definition.usages[0].id] && definition.usages[0].variant=='MANDATORY'}]">
                  {{ ctaLabelPrefix }}
                  <a :href="fallbackLink" style="display: inline-block;" target="_blank" rel="noopener noreferrer">
                    {{ ctaLabel }}
                  </a>
                  {{ ctaLabelSuffix }}
                  <span v-if="definition.usages[0].variant=='MANDATORY'">*</span>
                </p>
              </div>
              <div class="checkbox-error">
                <span v-if="!form.check[definition.usages[0].id] && v$.form.check.$dirty && definition.usages[0].variant=='MANDATORY'" :class="brandClass">
                  {{ errorRequiredLabel }}
                </span>
              </div>
          </template>
        </div>
      </div>
    </div>
    <div class="consents-info" :class="brandClass" v-for="(usage, index) in getUserConsentsUsageTextsByTagName('afterUsageDef')" :key="`policy-after-${index}`">
      <div class="consents-usage-text after" :id="'policy-after-consents-usage-text'">{{usage.text}}</div> 
      <OneTippy
          :labelledBy="'policy-after-consents-usage-text'"
          :name="`policy-after-popup-${index}`"
          :visible="usage.popupVisible"
          v-if="usage.popup"
          :html="usage.popup"
          :placement="'top-start'"
          :maxWidth="500"
          :brandClass="brandClass"
        />
    </div>
    <div class="consents-title" :class="brandClass" v-for="(usage, index) in getUserConsentsUsageTextsByTagName('footer')" :key="`policy-footer-${index}`">
      <div class="consents-usage-text" :labelledBy="'policy-footer-consents-usage-text'">{{usage.text}}</div> 
      <OneTippy
        :labelledBy="'policy-footer-consents-usage-text'"
        :name="`footer-popup-${index}`"
        :visible="usage.popupVisible"
        v-if="usage.popup"
        :html="usage.popup"
        :placement="'top-start'"
        :maxWidth="500"
        :brandClass="brandClass"
      />
    </div>

  </div>
</template>

<script>
import useVuelidate from '@vuelidate/core'
import oneUtils from "../../../gcdm-one-library/gcdm-one-utils/src/bootstrap";
import OneTippy from "../../../gcdm-one-library/gcdm-one-tippy/src/OneTippy";
import OneCheckbox from "../../../gcdm-one-library/gcdm-one-checkbox/src/OneCheckbox";
import { defineComponent } from 'vue'

export default defineComponent({
  setup() {
    return { v$: useVuelidate() }
  },
  emits: ['policyDowloaded','policyUpdated','onClose'],
  name: "OnePolicyConsents",
  props: {
    brandClass:{
      type: String,
      required: true,
      default: '__b'
    },
    t:{
      type: Function,
      required: true
    },
    c:{
      type: Function,
      required: true
    },
    modelValue:null, 
    policyConfig:null, 
    closeIfError:null, 
    isProfileSection:false, 
    policyIndex:null
  },
  components: {OneTippy, OneCheckbox, oneUtils},
  data: () => ({
    form: {
      check: {},
    },
    alreadyInDownload: false,
    policy: null,
    currentPolicy: null,
    thereIsAnError: false,
    initializated: false,
    fallbackLink: "",
    isMounted: false,
  }),
    validations: {
    form: {
      check: {
      }
    },
  },
  computed: {
    userPolicyConsents(){
      return this.$store.getters.getUser.contactPolicyConsents
    },
    ctaLabelPrefix() {
      return this.policyConfig
        ? this.t(`policy_${this.policyConfig.type}_prefix`)
        : "";
    },
    ctaLabel() {
      return this.policyConfig
        ? this.t(`policy_${this.policyConfig.type}_link`)
        : "";
    },
    ctaLabelSuffix() {
      return this.policyConfig
        ? this.t(`policy_${this.policyConfig.type}_suffix`)
        : "";
    },
    errorRequiredLabel() {
      return this.policyConfig
        ? this.t(`policy_${this.policyConfig.type}_error_required`)
        : "";
    },
    isPolicyConsentNeeded() {
      if(this.policyConfig.type!="mrk_type"){
        return !!this.policyConfig.policy_document_name
      }else if (!this.isProfileSection){
        return this.c('show_registration_marketing_consents');
      }else{
        return this.c('show_profile_marketing_consents');
      }
    }
  },
  watch: {
    "$store.state.configurationParams": {
      deep: true,
      handler(newVal, oldVal) {
        if (newVal.country !== oldVal.country) {
          console.log(`[PolicyConsent] country change detected: '${oldVal.country}' -> '${newVal.country}'`);
          if(!this.alreadyInDownload && this.isMounted) {
            this.initPolicyConsent();
          }
        }
        if (newVal.language !== oldVal.language) {
          console.log(`[PolicyConsent] language change detected: '${oldVal.language}' -> '${newVal.language}'`);
          if(!this.alreadyInDownload && this.isMounted) {
            this.configurePolicyConsent();
          }
        }
      },
    },
    "userPolicyConsents":{
      deep: true,
      handler(newVal, oldVal) {
        if (newVal && newVal.length) {
          console.log(`[PolicyConsent] user policy consents change detected`);
          if(!this.alreadyInDownload && this.isMounted) {
            this.configurePolicyConsent();
          }
        } 
      },
    }
  },
  async mounted() {
    const awaitImport = await import('../../../gcdm-one-library/gcdm-one-moment/src/bootstrap');
    this.oneMoment = (awaitImport).default;
    if (!this.alreadyInDownload) {
      this.initPolicyConsent();
      this.isMounted=true;
    }
  },
  methods: {
    selectAll(isSelecting){
      for (const definition of this.currentPolicy.usageDefinitions){
        for (const u of definition.usages) {
          this.form.check[u.id] = isSelecting;
        }
      }
      this.v$.form.check.$touch();
    },  
    /**
     * Return the implict variant usage definition
     */
    checkImplicitVariantInsideUsageDefinition(definition){
      return definition.usages && definition.usages[0] && definition.usages[0].variant && definition.usages[0].variant=="IMPLICIT";
    },

    /**
     * Return the definition text primary if present
     */
    getTextPrimary(definition, usage) {
      if(definition.usages.length==1 ){
          return definition.textPrimary && definition.textPrimary.replace("<p>", "").replace("</p>", "") || "";
      }
      return usage.usage.label || usage.usage.name || this.t('profile_consents_label_not_found');
    },

    /**
     * Return the definition text primary if present
     */
    getTextPrimaryCombined(definition) {
      if(definition.usages.length==1 ){
          return definition.textPrimary && definition.textPrimary.replace("<p>", "").replace("</p>", "") || "";
      }
      return definition.textPrimary && definition.textPrimary.replace("<p>", "").replace("</p>", "") || this.t('profile_consents_label_not_found');
    },

    /**
     * Return the definition text secondary if present
     */

    getUsageDefinitionSecondary(definition){
      if(definition.textSecondary && (definition.usages.length==1 || !this.isProfileSection) ){
        return definition.textSecondary;
      }
      return null;
    },

    /**
     * Return the consents usage text if the
     * tag name is equal to header or footer
     */
    getUserConsentsUsageTextsByTagName: function(tagName){
      let textArray = [];
      if(
        this.currentPolicy && 
        this.currentPolicy.usageText
      ){
        textArray = this.populatePopupsFromUsage(tagName);
      }
      if(textArray.length && (tagName=='header' || tagName=='footer')){
        return [textArray[0]];
      }else{
        return textArray;
      }
    },

    /**
     * Return the current policy usage text
     */
    populatePopupsFromUsage: function(tagName){
      let toReturn = [];
      for (const [i, usageText] of this.currentPolicy.usageText.entries()) {
          if(usageText.tag==tagName){
            const usage = {
              text:usageText.value,
              popup:null,
              popupVisible:false
            };
            if(this.currentPolicy.usageText[i+1] && this.currentPolicy.usageText[i+1].tag=='popup'){
              usage.popup = this.currentPolicy.usageText[i+1].value;
            }
            toReturn.push(usage);
          }
        }
      return toReturn;
    },

    /**
     * This function update the policy consents
     */
    updateValue(usageId, definition, manageCombined) {
      let consent = 'REJECT';
      if(!this.form.check[usageId]){
        consent = 'ACCEPT'
      }
      //KR exception for marketing documents GCDM-227497 Legal requirement - KR Marketing consents relation on one page
      const isKorea = this.policy.country=="KR";
      const isMarketingDocument = this.policyConfig.type=="mrk_type";
      const isYellowCheckbox = definition.ordinalNumber === 1;
      const isBlueCheckbox = definition.ordinalNumber === 2;
      const isUnselecting = this.form.check[usageId];
      const yellowMarketingDefinition = this.currentPolicy.usageDefinitions.find(u=>u.ordinalNumber===1)
      const blueMarketingDefinition = this.currentPolicy.usageDefinitions.find(u=>u.ordinalNumber===2)
      if(isKorea && isMarketingDocument && isYellowCheckbox && isUnselecting){
        for (const u of blueMarketingDefinition.usages){
          this.form.check[u.id] = false;
          this.$emit("policyUpdated", {
            usageId: u.id,
            ...this.policyConfig,
            accepted: "REJECT"
          });
        }
      } else if(isKorea && isMarketingDocument && isBlueCheckbox && !isUnselecting){
        for (const u of yellowMarketingDefinition.usages){
          this.form.check[u.id] = true;
          this.$emit("policyUpdated", {
            usageId: u.id,
            ...this.policyConfig,
            accepted: "ACCEPT"
          });
        }
      }
      this.v$.form.check.$touch();
      if(manageCombined){
        for (const u of definition.usages) {
           this.$emit("policyUpdated", {
              usageId: u.id,
              ...this.policyConfig,
              accepted: consent
            });
        }
      }else{
        this.$emit("policyUpdated", {
          usageId: usageId,
          ...this.policyConfig,
          accepted: consent
        });
      }
    },

    /**
     * Show the notification error message
     */
    showError() {
      this.thereIsAnError = true;
      oneUtils.utils.showMessage("WARNING", this.t("error_generic"));
    },

    // Start management given consents

    createGivenConsents(toSendConsents) {
      if(this.userPolicyConsents && this.policyConfig.type=="mrk_type") {
        const givenConsents = this.getGivenConsents();
        toSendConsents.forEach(toSendConsent => {
          const givenConsent = givenConsents.find(c => c.usageId == toSendConsent.usageId) || 
                                givenConsents.find(c => c.usageId == toSendConsent.formerUsageId);
          if(givenConsent) {
            toSendConsent.consent = givenConsent.consent;
            this.form.check[toSendConsent.usage_id] = (givenConsent.consent === "ACCEPT");
          }
        });
      }

      return toSendConsents;
    },
    getGivenConsents() {
      let lastGivenConsents = this.userPolicyConsents.filter(consent => 
        consent.policyId == this.policy.name && 
        consent.country == this.policy.country
      )
      const lastConsentDate = Math.max(...lastGivenConsents.map(c => this.oneMoment.getTimestamp(c.consentDate) ));

      return lastGivenConsents.filter(consent => 
        this.oneMoment.getTimestamp(consent.consentDate) == lastConsentDate
      )
    },

    // End management given consents

    /**
     * This function build and retrun the contact policy consents
     */

    buildContactPolicyConsents(legalEntities, purposes, usages, brand) {
      const consents = [];
      for (const usage of usages) {
        this.form.check[usage.id]=false;
        for (const purpose of purposes) {
          for (const legalEntity of legalEntities) {
            consents.push({
              consent: "REJECT",
              consentDate: '',
              country: this.policy.country,
              language: this.currentPolicy.language,
              legalEntityId: legalEntity.name,
              majorVersion: this.policy.majorVersion,
              minorVersion: this.policy.minorVersion,
              policyId: this.policy.name,
              purposeId: purpose.purpose.name,
              touchpointId: this.c("_touchpoint_id"),
              usageId: usage.usage.name,
              variant: usage.variant,
              usage_id: usage.id,
              formerUsageId: usage.formerUsageId,
              brand: brand
            });
          }
        }
      }
      return consents;
    },

    /**
     * Return the policy filtered by language
     */
    getPolicyByLanguage(policy, language) {
      let filtered = policy.filter((e) => {
        return e.language.toLowerCase() === language.toLowerCase();
      });
      // if the there isn't the language we use the fallback language
      if (filtered.length === 0) {
        filtered = policy.filter((e) => {
          return (
            e.language.toLowerCase() ===
            oneUtils.properties.DEFAULT_FALLBACK_LANGUAGE
          );
        });
      }
      return filtered.length >= 1 ? filtered[0] : null;
    },

    /**
     * This function configure the policy consents
     */
    configurePolicyConsent() {
      this.thereIsAnError = false;
      let language = this.$store.state.configurationParams.language;
      //TOCHECK
      oneUtils.utils.sortTextBlock(this.policy.textBlocks);
      this.currentPolicy = this.getPolicyByLanguage(
        this.policy.textBlocks,
        language
      );
      //if no language found search for the fallback language
      if (!this.currentPolicy) {
        language = oneUtils.properties.DEFAULT_FALLBACK_LANGUAGE;
        this.currentPolicy = this.getPolicyByLanguage(
          this.policy.textBlocks,
          language
        );
      }
      const usageDefinitions = this.currentPolicy
        ? this.currentPolicy.usageDefinitions
        : null;
      if (usageDefinitions && usageDefinitions.length >= 1) {

        // FALLBACK if no textPrimary provided - START
        const fallbackUrlPattern = oneUtils.httpClient.prepareUrl(this.c("api_url_terms_condition_fallback"));
        this.fallbackLink = fallbackUrlPattern
          .replace(
            "${policy_document_name}",
            this.policyConfig.policy_document_name
          )
          .replace(
            "${country}",
             this.c('_terms_condition_fixed_country') || this.$store.state.configurationParams.country
          )
          .replace("${key_for_terms_condition_id}", this.c("key_for_terms_condition_id"))
          .replace("${language}", this.currentPolicy.language);
        // FALLBACK if no textPrimary provided - END
        let toSendConsents = [];
        for (const definition of usageDefinitions) {
          const computedConsents = this.buildContactPolicyConsents(definition.legalEntities, definition.purposes, definition.usages, this.currentPolicy?.brand?.name);
          toSendConsents = toSendConsents.concat(computedConsents);
        }
       toSendConsents = this.createGivenConsents(toSendConsents);
        this.$emit("policyDowloaded", {
          ...this.policyConfig,
          consents:toSendConsents,
          dirty:false
        });
      } else {
        if (this.closeIfError) {
          this.$emit('onClose');
        }else{
          this.showError();
        }
      }
      this.initializated = true;
    },

    // Start policy document management

    getPolicyDocument() {
      this.alreadyInDownload = true;
      oneUtils.httpClient
          .getPolicyDocument(this.policyConfig.policy_document_name)
          .then((res) => {
            this.policy=res;
            this.configurePolicyConsent();
          })
          .catch((err) => {
            if (this.closeIfError) {
              this.$emit('onClose');
            }else{
              this.showError();
              this.initializated = true;
            }
          }).finally(() => {
            this.alreadyInDownload = false;
          });
    },


    initPolicyConsent() {
      //reset form and emit null value
      this.initializated = false;
      this.thereIsAnError = false;
      //check if terms and conditions are need for this configuration
      if (this.isPolicyConsentNeeded) {
        this.getPolicyDocument();
      } else {
        console.debug("terms and condition are not needed...");
      }
    },

    // End policy document management

  },
});
</script>

<style lang="scss" scoped>
@import './styles/_variables.scss';
@import './styles/_fonts.scss';



    .consents-usage-text{
      display: inline;
    }
    .consents-title{
      margin-top: 15px;
      font-size: 14px;
      font-weight: bold;
      &.__m{
        font-size: 18px;
      }
    }
    .consents-info{
      font-size: 12px;
      line-height: 16px;
      margin-top: 8px;
      &.__m{
        font-size: 14px;
        line-height: 18px;
        margin-top: 10px;
        color: $tundora;
        font-weight: 600;
        font-family: MINISansSerif;
      }
      &.__motorrad {
        font-size: 14px;
        padding-bottom: 10px;
        .consents-usage-text {
          line-height: 22px;
          font-size: 16px;
          &.after {
            font-size: 14px;
          }
        }
      }
    }

    .checkbox-container {
      flex-wrap: wrap;
      display: flex;
      align-items: baseline;
      padding-top: 0;
      p {
        font-size: 16px;
        margin: 10px;
        margin-left: 15px;
        a{
          color: $black;
          text-decoration: underline;
          font-weight: bold;
        }
        &.__m{
          font-size: 18px;
        }
        &.__t{
          font-family: ToyotaSemibold;
        }
        &.invalid{
          color: $red;
          &.__motorrad{
            color: inherit
          }
        }
        
      }
    }
    .checkbox-error{
      margin-top: 5px;
      position: relative;
      flex: 0 0 100%;
      flex-basis:100%;
      span{
        position: absolute;
        color: $red;
        font-size: 12px;
        line-height: 14px;
        top: -15px;
        &.__d{
          color: $darkmodeRed
        }
        &.__motorrad {
          font-size: 14px;
        }
      }
    }


  .consents-container{
    margin-bottom: 16px;
    &.__motorrad {
      margin-bottom: 32px;
    }
    .consents-checkbox-container{
      display: flex;
      .consents-usage-label{
        display: inline;
        font-size: 16px;
        line-height: 24px;
        width: 90%;
      }
    }
    .all-consents{
      margin-bottom: 10px;
      &.__motorrad {
          margin-top: 16px;
      }
    }
    .consents-title{
      margin-top: 15px;
      font-size: 14px;
      font-weight: bold;
      &.__motorrad {
        font-size: 16px;
      }
    }

    .consents-usage-text{
      display: inline;
    }


    &.__t{
      .consents-checkbox-container{
        font-family: ToyotaSemibold;
      }
    }
    &.__alphabet{
      font-size: 16px;
      font-weight: 500;
      font-family: AlphabetSansPro-Medium;
      .consents-checkbox-container{
        .consents-usage-label{
          color: $alphabetblue;
        }      
      }
    }
    &.__m{
      .consents-checkbox-container{
        font-size: 18px;
        width: 100%;
        font-family: MINISansSerif;
        // .checkbox-label{
        //   line-height: 24px;
        //   font-weight: normal;
        //   font-family: MINISansSerif;
        // }   
        .consents-usage-label{
          font-size: 18px;
          margin-top: 3px;
        }
      }
      .consents-title{
        font-size: 18px;
      }

      .consents-info{
        font-size: 14px;
        line-height: 18px;
        margin-top: 10px;
        color: $tundora;
        font-weight: 600;
        font-family: MINISansSerif;
      }
    }
  }

</style>
